import gql from "graphql-tag";

export default gql`
  query EngagementStatsByTickerSymbol($tickerSymbol: TickerSymbol!, $country: SecurityCountry!) {
    issuerByTickerSymbol(tickerSymbol: $tickerSymbol, country: $country) {
      ... on AmericanCompanyIssuer {
        _id
        engagementStats {
          totalDiscussionsCommentsCount
          viewerUnseenDiscussionsCommentsCount
        }
      }
      ... on BrazilianCompanyIssuer {
        _id
        engagementStats {
          totalDiscussionsCommentsCount
          viewerUnseenDiscussionsCommentsCount
        }
      }
      ... on BrazilianRealEstateFund {
        _id
        engagementStats {
          totalDiscussionsCommentsCount
          viewerUnseenDiscussionsCommentsCount
        }
      }
    }
  }
`;
